var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.to
    ? _c(
        "router-link",
        { staticClass: "link", attrs: { to: _vm.to, replace: "" } },
        [_vm._t("default")],
        2
      )
    : _c(
        "a",
        {
          staticClass: "link",
          attrs: { role: "button" },
          on: { click: _vm.clickFn }
        },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }